export default __webpack_public_path__ + "static/media/white-location-icon.6cfa83f6.svg";